import { createSlice } from '@reduxjs/toolkit'

export const CampaignMemberFilterSlice = createSlice({
  name: 'campaign_member_only_filter',
  initialState: {
    value: false,
  },
  reducers: {
    setMemberOnlyStatus: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { setMemberOnlyStatus } = CampaignMemberFilterSlice.actions

export default CampaignMemberFilterSlice.reducer